export default "__VITE_ASSET__CZWHKLUb__"